import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { withdraw } from "../../../../../../services/pos/Tables";

const WithdraweModal = ({ open, onClose, bank_id, onSuccess }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [formData, setFormData] = useState({
    bank_id: bank_id || "",
    amount: "",
    withdrawal_title: "",
    withdrawal_description: "",
    transaction_date: "",
    root_id: "",
  });

  useEffect(() => {
    if (bank_id) {
      setFormData((prev) => ({
        ...prev,
        bank_id: bank_id,
      }));
    }
  }, [bank_id]);

  useEffect(() => {
    if (open) {
      setFormData({
        bank_id: bank_id || "",
        amount: "",
        withdrawal_title: "",
        withdrawal_description: "",
        transaction_date: "",
        root_id: "",
      });
    }
  }, [open, bank_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      ...formData,
      bank_id: bank_id || "",
      root_id: formData.root_id || "",
    };

    const { amount, withdrawal_title, transaction_date } = payload;

    if (!amount || !withdrawal_title || !transaction_date) {
      alert("❌ يرجى ملء جميع الحقول المطلوبة.");
      return;
    }

    try {
      await withdraw(payload);
      alert("✅ تم تسجيل عملية السحب بنجاح.");
      onSuccess?.();
      onClose?.();
    } catch (error) {
      alert(`❌ فشل في عملية السحب:\n${error?.message || ""}\n${error?.error || ""}`);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          m: { xs: 0, sm: 2 },
          maxHeight: { xs: "100%", sm: "90vh" },
          width: { xs: "100%", sm: "auto" },
        }
      }}
    >
      <DialogTitle sx={{ 
        fontSize: { xs: "18px", sm: "20px", md: "24px" },
        py: { xs: 1.5, sm: 2 },
        fontWeight: 600,
      }}>
        سحب من الخزنة
      </DialogTitle>
      <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Box sx={{ mt: { xs: 0.5, sm: 1 } }}>
          <Typography 
            variant={isMobile ? "subtitle1" : "h6"} 
            mb={{ xs: 1.5, sm: 2 }}
            sx={{ fontSize: { xs: "16px", sm: "18px", md: "20px" } }}
          >
            تسجيل عملية سحب
          </Typography>
          <Box display="flex" flexDirection="column" gap={{ xs: 1.5, sm: 2 }}>
            <TextField
              label="المبلغ"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={handleChange}
              fullWidth
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="عنوان السحب"
              name="withdrawal_title"
              value={formData.withdrawal_title}
              onChange={handleChange}
              fullWidth
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="وصف السحب"
              name="withdrawal_description"
              value={formData.withdrawal_description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={isMobile ? 2 : 3}
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="تاريخ العملية"
              name="transaction_date"
              type="date"
              value={formData.transaction_date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true, style: { fontSize: isMobile ? "14px" : "16px" } }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
              fullWidth
              size={isMobile ? "small" : "medium"}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ 
        p: { xs: 2, sm: 2 },
        gap: { xs: 1, sm: 1 },
        flexDirection: { xs: "column-reverse", sm: "row" },
      }}>
        <Button 
          onClick={onClose}
          fullWidth={isMobile}
          size={isMobile ? "medium" : "large"}
          sx={{ fontSize: { xs: "14px", sm: "15px" } }}
        >
          إلغاء
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSubmit}
          fullWidth={isMobile}
          size={isMobile ? "medium" : "large"}
          sx={{ fontSize: { xs: "14px", sm: "15px" } }}
        >
          تسجيل السحب
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WithdraweModal;
